import { Component, Input } from "@angular/core";

@Component({
  selector: "app-badglet",
  templateUrl: "./badglet.component.html",
  styleUrls: ["./badglet.component.scss"],
  standalone: false,
})
export class BadgletComponent {
  @Input() color: string;

  constructor() {}
}
